import { Injectable } from '@angular/core';
import { User } from '../interfaces/user';
import { Exercise } from '../interfaces/exercise';
import { BehaviorSubject, Subject } from 'rxjs';
import { RoutineGroup } from '../interfaces/routine';
import { Tutorial } from '../interfaces/tutorial';
import { Food } from '../interfaces/food';
import { FoodOption } from '../interfaces/food-option';
import { Diet } from '../interfaces/diet';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  selectedUser?: User;
  selectedExerciseToAddTutorial?: Exercise;
  selectedRoutineGroup?: RoutineGroup;
  selectedTutorial?: Tutorial;
  selectedDiet?: Diet;
  selectedTabletRoutine: any;
  selectedWorkoutId?: number;

  // Food Form Modal
  selectedFood?: Food;
  selectedFoodOption?: FoodOption;
  selectedFoodGroup?: number = undefined;

  // Modal information
  openModal: any;

  //tablets

  selectedTabletTutorialId?: number;

  // Observables
  selectedImportSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedImportUserData$ = this.selectedImportSubject.asObservable();

  editingSource = new Subject<boolean>();
  edition$ = this.editingSource.asObservable();

  private modalShowSubject = new BehaviorSubject<string>('');
  modalShow$ = this.modalShowSubject.asObservable();

  constructor() {}

  updateSelectedImportuser(value: User) {
    this.selectedImportSubject.next(value);
  }

  updateEdition(editing: boolean) {
    this.editingSource.next(editing);
  }

  setModalShow(modalShow: string): void {
    this.modalShowSubject.next(modalShow);
  }
}
